import { HttpResponse, fileDaoFactory } from '../common'
import { errorUtil } from '../util/error-util'

const dao = fileDaoFactory({
  onError: async (error: Error) => {
    errorUtil.handleHttpError(error)
  },
})

export const fileDao = {
  downloadFile: async ({ fileId }: { fileId: string }): Promise<{ base64: string; mimeType: string; fileName: string }> => {
    // TODO check if we need to set "Accept-Encoding": "gzip, deflate, br" here
    const result = await dao._http.get(`/files/${fileId}/download`, { responseType: 'arraybuffer' })
    const uint8Array = new Uint8Array(result.data)
    let binaryString = ''
    for (let i = 0; i < uint8Array.length; i++) {
      binaryString += String.fromCharCode(uint8Array[i])
    }
    const base64 = btoa(binaryString)
    const mimeType = result.headers['content-type']
    const fileName = result.headers['content-file-name']
    return { base64, mimeType, fileName }
  },
  downloadBase64FileByFileId: async (fileId: string): Promise<string> => {
    if (!fileId) {
      return ''
    }
    const { base64, mimeType } = await fileDao.downloadFile({ fileId })
    return `data:${mimeType};base64,${base64}`
  },
  uploadFile: async (file: File): Promise<string> => {
    const formData = new FormData()
    formData.append('file', file)
    const result = await dao._http.post<HttpResponse<{ fileId: string }>>('/files/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return result.data.data[0].fileId
  },
}
